import { render } from "./imgAppVcard.vue?vue&type=template&id=5a6f7708&scoped=true"
import script from "./imgAppVcard.vue?vue&type=script&lang=js"
export * from "./imgAppVcard.vue?vue&type=script&lang=js"

import "./imgAppVcard.vue?vue&type=style&index=0&id=5a6f7708&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5a6f7708"]])

export default __exports__